import React from "react";
import * as Icon from "react-feather";
import { toast as alert } from "react-toastify";

import "./custom-tax-rate-row.css";

import BookkeepingService from "../../../../services/BookkeepingService";
import WComponent from "../../../common/WComponent";

export const CUSTOM_RATE_OPTION_VALUE = "__custom__";
export const COMMON_TAX_NAMES = ["GST", "PST", "HST", "QST", "GST & PST"];

/**
 * The row a preparer types a tax rate into when the province's list does not have the one they
 * need. Every screen that offers "+ Custom rate…" shows this same row, so a rate is named,
 * validated and remembered the same way wherever it is added.
 *
 * The rate is added to the client's own list before it is handed back, because a rate typed once
 * is a rate the client uses, and re-typing it on the next transaction is how two spellings of one
 * rate get onto a file. What to do with the rate afterwards is the caller's business: one screen
 * applies it to a transaction, another sets it as an account's default.
 */
class CustomTaxRateRow extends WComponent {
	constructor(props) {
		super(props);

		this.state = { name: "", percent: "" };
	}

	onApply = async () => {
		const { clientId, taxOptions = [], customTaxRates = [], onApply, onCustomTaxRatesChange } = this.props;
		const typedName = this.state.name.trim();

		const built = BookkeepingService.buildCustomTaxRateOption({ name: typedName || "Custom", ratePercent: this.state.percent });
		if (built.error) {
			alert.error(built.error);
			return;
		}

		const theClientAlreadyHasIt = taxOptions.includes(built.option);
		if (!theClientAlreadyHasIt) {
			const updatedRates = [...customTaxRates, built.option];
			BookkeepingService.saveCustomTaxRates({ clientId, customTaxRates: updatedRates });
			if (onCustomTaxRatesChange) onCustomTaxRatesChange(updatedRates);
		}

		await onApply({ option: built.option });
	};

	render() {
		const { onCancel } = this.props;
		const { name, percent } = this.state;

		return (
			<div className="bk-tax-rate-row">
				<input
					className="tk-input bk-tax-rate-row__name"
					list="bk-tax-rate-name-options"
					placeholder="Tax name (optional)…"
					value={name}
					onChange={event => this.update({ name: event.target.value })}
				/>
				<datalist id="bk-tax-rate-name-options">
					{COMMON_TAX_NAMES.map(taxName => (
						<option key={taxName} value={taxName} />
					))}
				</datalist>
				<input
					className="tk-input bk-tax-rate-row__percent"
					type="number"
					step="0.01"
					min="0"
					max="100"
					placeholder="%"
					value={percent}
					onChange={event => this.update({ percent: event.target.value })}
					autoFocus
				/>
				<button type="button" className="tk-button tk-button--secondary" onClick={this.onApply} disabled={percent === ""}>
					<Icon.Check size={14} />
					Apply
				</button>
				<button type="button" className="tk-button tk-button--secondary" onClick={onCancel}>Cancel</button>
			</div>
		);
	}
}

export default CustomTaxRateRow;
